import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getFieldValue } from "@store/Store/Components/ContactUsForm/ContactUsFormSelectors";
import { useSelector } from "react-redux";

const useFieldValue = (key: string) => {
    return useSelector((state: ApplicationState) => getFieldValue(state, key));
};

export default useFieldValue;
